var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlternateEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94271 1.43213C4.72271 1.43213 2.10938 4.04546 2.10938 7.26546C2.10938 10.4855 4.72271 13.0988 7.94271 13.0988H10.8594V11.9321H7.94271C5.41104 11.9321 3.27604 9.79713 3.27604 7.26546C3.27604 4.7338 5.41104 2.5988 7.94271 2.5988C10.4744 2.5988 12.6094 4.7338 12.6094 7.26546V8.09963C12.6094 8.56046 12.1952 9.01546 11.7344 9.01546C11.2735 9.01546 10.8594 8.56046 10.8594 8.09963V7.26546C10.8594 5.65546 9.55271 4.3488 7.94271 4.3488C6.33271 4.3488 5.02604 5.65546 5.02604 7.26546C5.02604 8.87546 6.33271 10.1821 7.94271 10.1821C8.74771 10.1821 9.48271 9.85546 10.0077 9.32463C10.3869 9.8438 11.0402 10.1821 11.7344 10.1821C12.8835 10.1821 13.776 9.2488 13.776 8.09963V7.26546C13.776 4.04546 11.1627 1.43213 7.94271 1.43213ZM7.94271 9.01546C6.97438 9.01546 6.19271 8.2338 6.19271 7.26546C6.19271 6.29713 6.97438 5.51546 7.94271 5.51546C8.91104 5.51546 9.69271 6.29713 9.69271 7.26546C9.69271 8.2338 8.91104 9.01546 7.94271 9.01546Z",
    fill: "#407BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.943359 0.265625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternateEmail);
export default __webpack_public_path__ + "static/media/alternate_email.474999e68ade28f218120aea42e516fb.svg";
export { ForwardRef as ReactComponent };